import React, { useState } from 'react';
import './Tooltip.css';

export function Tooltip(props) {
    return <div className="mytooltip">
        <span className="tooltiptext">{props.value}</span>
        {props.children}
        </div>
}